import { toLocalFormat, toUTC } from 'core/classes/helpers/DateHelper'

import { create as createUserEvent, TEventName, IModel as TUserEvent } from './UserEvent'

class UserEventDispatcher {
  public readonly email: string

  constructor(email: string) {
    this.email = email
  }

  public dispatch(eventName: TEventName, events: TUserEvent[]): TUserEvent | null {
    let result = null
    switch (eventName) {
      case 'login': {
        const wasToday = this.getEventsByNameAndDate(events, eventName, new Date()).length > 0
        const totalValue = this.getEventsTotalsByName(events, eventName)
        if (!wasToday && totalValue <= 300) {
          result = createUserEvent({
            email: this.email,
            event: eventName,
            value: 10,
          })
        }
        break
      }
      case 'add_partner':
      case 'change_preferred_phone': {
        const todayCount = this.getEventsByNameAndDate(events, eventName, new Date()).length
        if (todayCount < 30) {
          result = createUserEvent({
            email: this.email,
            event: eventName,
            value: 3,
          })
        }
        break
      }
      default:
        result = null
    }
    return result
  }

  protected getEventsByNameAndDate(
    events: TUserEvent[],
    eventName: string,
    date: Date
  ): TUserEvent[] {
    const currentUtcDateString = toUTC(date)
    return events.filter((i) => {
      return i.event === eventName && toLocalFormat(i.created) === currentUtcDateString
    })
  }

  protected getEventsTotalsByName(events: TUserEvent[], eventName: string): number {
    return events.reduce((a, i) => a + (i.event === eventName ? 1 : 0), 0)
  }
}

export default UserEventDispatcher
